import { Box, Container, css, styled } from '@mui/material'

import { AppButton } from '../../inputs/app-button'
import { Separator } from '../../layout/separator/Separator'

export type ButtonType = 'primary' | 'secondary' | 'delete' | 'delete-inverted'

export interface ButtonProps {
  label: string
  icon?: JSX.Element
  variant: ButtonType
  fullWidth?: boolean
  disabled?: boolean
  isLoading?: boolean
  onClick?: () => void
  'data-testid'?: string
}

const MainContainer = styled(Container, {
  shouldForwardProp: (prop: string) => !prop.startsWith('$'),
})<{
  $noBorder?: boolean
  $noAlertPadding?: boolean
}>`
  &.Mui-BottomActionBar {
    ${({ $noBorder }) =>
      $noBorder &&
      css`
        border: unset;
        box-shadow: unset;
      `}
  }
  & .Mui-ButtonWrapper:first-child {
    ${({ $noAlertPadding }) =>
      $noAlertPadding &&
      css`
        padding-bottom: 0px;
      `}
  }
`

const AlertContainer = styled('div')`
  & > * {
    width: 100%;
  }
`

export interface BottomActionBarProps {
  primaryButtonProps?: ButtonProps
  secondaryButtonProps?: ButtonProps
  alert?: JSX.Element
  helperText?: JSX.Element
  noBorder?: boolean
  noAlertPadding?: boolean
}

export const BottomActionBar = ({
  primaryButtonProps,
  secondaryButtonProps,
  alert,
  helperText,
  noBorder,
  noAlertPadding,
}: BottomActionBarProps) => {
  return (
    <MainContainer
      className="Mui-BottomActionBar"
      $noBorder={noBorder}
      $noAlertPadding={noAlertPadding}
    >
      {alert && (
        <AlertContainer className="Mui-ButtonWrapper">{alert}</AlertContainer>
      )}
      <Box className="Mui-ButtonWrapper">
        {secondaryButtonProps && (
          <AppButton
            variant={secondaryButtonProps.variant}
            disabled={secondaryButtonProps.disabled}
            isLoading={secondaryButtonProps.isLoading}
            fullWidth={secondaryButtonProps.fullWidth}
            onClick={secondaryButtonProps.onClick}
            data-testid={secondaryButtonProps['data-testid']}
          >
            {secondaryButtonProps.label}
            {secondaryButtonProps.icon && (
              <>
                <Separator horizontalMargin="XS" />
                {secondaryButtonProps.icon}
              </>
            )}
          </AppButton>
        )}
        {primaryButtonProps && (
          <AppButton
            variant={primaryButtonProps.variant}
            disabled={primaryButtonProps.disabled}
            isLoading={primaryButtonProps.isLoading}
            fullWidth={primaryButtonProps.fullWidth}
            onClick={primaryButtonProps.onClick}
            data-testid={primaryButtonProps['data-testid']}
          >
            {primaryButtonProps.label}
            {primaryButtonProps.icon && (
              <>
                <Separator horizontalMargin="XS" />
                {primaryButtonProps.icon}
              </>
            )}
          </AppButton>
        )}
      </Box>
      {helperText}
    </MainContainer>
  )
}
